'use strict'

/**
 * A utility function to workon elements if they exist.
 * @param {node} or {[nodes]} -- dom element or elements
 * @param {function} callback
 * @param {args} optional comma separated argument values for callback
 * @returns {promise}
 */
export function bootstrap(element, callback, ...args) {
  return new Promise((res, rej) => {
    if (!element) {
      return res(null)
    }

    // recursively call bootstrap on each element provided
    if (Array.isArray(element)) {
      const promises = Promise.all(element.map(el => bootstrap(el, callback, ...args)))
      return promises
        .then(res)
        .catch(rej)
    }

    const params = args.splice(0)
    params.unshift(element)
    res(callback.apply(this, params))
  })
}
